export default "__VITE_ASSET__CwEsa_Xx__"